const LANGUAGE = {
  EN: 'en',
  TH: 'th'
} as const

const FETCH_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error'
}

const DEFAULT_IMAGE_PATH = {
  AVARTAR: '/images/contents/avatar-default.png',
}

const NODE_FLOW = {
  NODE_TYPE_LIST: ['agent', 'action', '__end__', 'custom', 'http']
}

const TYPE_APPLICATION = {
  APPLICATION: 'application',
}

const SOCIAL_MEDIA_LIST = ['Facebook', 'Line', 'Whatsapp', 'Instagram', 'LinkedIn', 'Website', 'Mobile App',]
// const SOCIAL_MEDIA_LIST = ['Facebook', 'Line', 'Whatsapp', 'Instagram', 'X (Twitter)', 'LinkedIn', 'Mobile App', 'Website']

export const DATA = {
  LANGUAGE,
  FETCH_STATUS,
  DEFAULT_IMAGE_PATH,
  NODE_FLOW,
  TYPE_APPLICATION,
  SOCIAL_MEDIA_LIST
};

export type ILANGUAGE = (typeof LANGUAGE)[keyof typeof LANGUAGE]
